
import { defineComponent } from 'vue';
import CourseDetailModalGlobalInjector from "@/components/modals/global-injectors/CourseDetailModalGlobalInjector.vue";
import AppointmentDetailModalGlobalInjector from "@/components/modals/global-injectors/AppointmentDetailModalGlobalInjector.vue";
import RegionProductsModalGlobalInjector from "@/components/modals/global-injectors/RegionProductsModalGlobalInjector.vue";
import ContactFormRegionModalGlobalInjector from "@/components/modals/global-injectors/ContactFormRegionModalGlobalInjector.vue";

export default defineComponent({
    name: 'App',
    components: {
        ContactFormRegionModalGlobalInjector,
        CourseDetailModalGlobalInjector,
        AppointmentDetailModalGlobalInjector,
        RegionProductsModalGlobalInjector,
    },
});
